import { useState } from "react";
import "../../assets/css/application.scss";

const AccordionSection = ({ id, title, isOpen, onToggle, children }) => (
  <section className={`policy-section accordion ${isOpen ? "open" : ""}`} id={id}>
    <button onClick={() => onToggle(id)} aria-expanded={isOpen}>
      {title}
    </button>
    <div data-panel>{children}</div>
  </section>
);

function ServicePage() {
  const [openSections, setOpenSections] = useState({
    "sec-1": true,
    "sec-2": true,
    "sec-3": true,
    "sec-4": true,
    "sec-5": true,
    "sec-6": true,
    "sec-7": true,
    "sec-8": true,
    "sec-9": true,
    "sec-10": true,
    "sec-11": true,
    "sec-12": true,
    "sec-13": true,
    "sec-14": true,
    "sec-15": true,
  });

  const toggleAccordion = (sectionId) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  return (
    <div className="service-wrap">
      <header>
        <div className="brand">
          <div className="brand-logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                d="M6 12h12M6 16h8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="brand-text">
            <h1>키즈다 — 이용약관</h1>
            <p>최종 업데이트: 2026년 9월 1일</p>
          </div>
        </div>
        <a href="#toc" className="btn">
          목차 바로가기
        </a>
      </header>

      <div className="container">
        <main>
          <h2 className="doc-title">이용약관</h2>
          <br />

          <AccordionSection
            id="sec-1"
            title="제 1 조 (목적)"
            isOpen={openSections["sec-1"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              이 약관은 주식회사 위고컴퍼니(이하 "회사")가 운영하는 키즈다 및
              관련 제반 서비스(이하 "서비스")를 이용하는 고객(이하 "회원")과
              회사 간에 서비스의 이용조건 및 절차, 권리와 의무, 기타 필요한
              사항을 규정함을 목적으로 합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-2"
            title="제 2 조 (정의)"
            isOpen={openSections["sec-2"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. "회원"이란 이 약관에 동의하고 회사와 이용계약을 체결한 자로서,
              계정의 명의자인 보호자(만 19세 이상의 성인)를 말합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. "계정"이란 회원 식별과 서비스 이용을 위하여 회원이 설정한
              아이디(ID)와 비밀번호를 포함한 회원 단위를 말합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. "자녀 프로필"이란 회원이 자신의 계정 내에 생성하는 자녀(아동)용
              이용 단위를 말하며, 별도의 아이디·비밀번호를 갖지 않고 회원의
              계정에 귀속됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. "기기 연결"이란 회원이 발급한 연결 코드(또는 QR)를 통해 자녀가
              사용하는 기기를 특정 자녀 프로필 전용으로 등록하는 것을 말합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. "보호자 PIN"이란 자녀의 보호자 기능(결제·관리 등) 접근을
              제한하기 위해 회원이 설정하는 비밀번호를 말합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. "구독"이란 회사가 정한 이용요금을 결제하고 구독 회원 전용
              서비스를 이용하는 것을 말합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              7. "소셜 로그인"이란 Google, Apple 등 외부 인증 사업자가 제공하는
              계정으로 서비스에 가입하거나 로그인하는 것을 말합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-3"
            title="제 3 조 (약관의 효력과 변경)"
            isOpen={openSections["sec-3"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 이 약관은 회원이 회원가입 시 "동의" 버튼을 누름과 동시에 동의한
              것으로 간주되며, 온라인을 통해 공시함으로써 효력이 발생합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 「약관의 규제에 관한 법률」 등 관계 법령을 위배하지 않는
              범위에서 이 약관을 변경할 수 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사가 약관을 변경할 경우에는 적용일자 및 변경 사유를 명시하여
              적용일 7일 전부터 서비스 내 공지합니다. 다만, 회원에게 불리하거나
              중대한 사항의 변경은 적용일 30일 전부터 공지하며, 앱 푸시 또는
              전자우편 등으로 개별 통지하도록 노력합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회원은 변경된 약관에 동의하지 않을 경우 적용일 전까지 거부
              의사를 표시하고 이용계약을 해지할 수 있으며, 변경된 약관의
              효력발생일 이후 서비스를 계속 이용하는 경우 변경 사항에 동의한
              것으로 봅니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-4"
            title="제 4 조 (약관 외 준칙)"
            isOpen={openSections["sec-4"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              이 약관에 명시되지 않은 사항에 대해서는 국내 관련 법령 규정에
              따릅니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-5"
            title="제 5 조 (이용계약의 체결)"
            isOpen={openSections["sec-5"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 이용계약은 가입 신청자가 약관에 동의하고 회원가입을 신청한 후
              회사가 이를 승낙함으로써 성립합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회원가입은 휴대폰 본인인증을 완료한 보호자 본인 명의로만 신청할
              수 있습니다. 만 14세 미만 아동은 회원으로 가입할 수 없으며, 보호자
              회원의 계정 내 자녀 프로필을 통해 서비스를 이용할 수 있습니다.
              [2026년 10월 중 시행 — 부칙 제2조]
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회원가입 및 로그인은 아이디·비밀번호 방식 또는 소셜 로그인
              방식으로 할 수 있습니다. 소셜 로그인으로 가입하는 경우에도 제2항의
              휴대폰 본인인증을 거쳐야 하며, 소셜 로그인 계정은 신규 계정으로
              생성되고 기존 아이디·비밀번호 계정과 연동되지 않습니다. 동일인
              명의의 기존 계정이 확인되는 경우 회사는 신규 가입을 제한하고 기존
              계정의 이용을 안내할 수 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회사는 신청 내용이 허위이거나 타인의 명의를 도용한 경우, 기타
              규정한 제반 사항을 위반하여 신청한 경우 가입 신청을 거절하거나
              사후에 이용계약을 해지할 수 있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-6"
            title="제 6 조 (가족 계정 및 자녀 프로필)"
            isOpen={openSections["sec-6"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 회원은 자신의 계정 내에 자녀 프로필을 최대 3개까지 생성할 수
              있습니다. [2026년 10월 중 시행]
            </p>
            <p style={{ fontSize: "small" }}>
              2. 자녀 프로필은 회원의 계정에 귀속되며, 자녀 프로필 단위의 별도
              아이디·비밀번호는 제공되지 않습니다. 자녀 프로필의 생성·수정·삭제
              및 이용에 대한 관리 권한과 책임은 회원(보호자)에게 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회원이 구독 중인 경우 구독 회원 전용 서비스는 해당 계정의 모든
              자녀 프로필에 자동으로 공유됩니다. 구독 공유를 위한 별도의 신청
              절차는 없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회원은 연결 코드를 발급하여 자녀의 기기를 자녀 프로필 전용으로
              등록(기기 연결)할 수 있습니다. 연결 코드는 발급 후 10분간 1회에
              한하여 유효하며, 자녀 프로필 1개당 최대 2대의 기기를 연결할 수
              있고 기기 1대에는 1개의 자녀 프로필만 연결할 수 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. 회원이 기기 연결을 해제하면 해당 기기에서의 자녀 프로필 이용은
              즉시 종료됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. 회원은 보호자 PIN을 설정하여 자녀의 보호자 기능(결제·프로필
              관리 등) 접근을 제한할 수 있으며, PIN 및 연결 코드의 관리 책임은
              회원에게 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              7. 자녀 프로필을 삭제하는 경우 해당 프로필의 활동 정보는
              삭제일로부터 30일간 보관 후 파기되며, 보관 기간 내 회원의 요청으로
              복구할 수 있습니다. 세부 사항은 개인정보처리방침에 따릅니다.
            </p>
            <p style={{ fontSize: "small" }}>
              8. 회원을 탈퇴하는 경우 계정에 귀속된 모든 자녀 프로필 및 그 활동
              정보도 함께 삭제됩니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-7"
            title="제 7 조 (이용계약의 해지)"
            isOpen={openSections["sec-7"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 회원은 회사에 언제든 이용계약의 해지(회원탈퇴)를 요청할 수
              있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 회원의 해지 요청이 접수된 즉시 회원을 탈퇴 처리하고,
              관련 법령 및 개인정보처리방침에 명시된 경우를 제외한
              개인정보(자녀 프로필 정보 포함)를 삭제합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사는 회원이 제11조(회원의 의무)에 위배되는 행위를 한 경우
              사전통지 없이 이용계약을 해지하거나 서비스 이용을 제한·정지할 수
              있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-8"
            title="제 8 조 (서비스)"
            isOpen={openSections["sec-8"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사는 다음과 같은 서비스를 제공합니다.
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>
                ① 뉴스 서비스: 어린이 대상 뉴스 콘텐츠 (구독 여부와 관계없이 전
                이용자에게 제공)
              </li>
              <li style={{ fontSize: "small" }}>
                ② 구독 회원 전용 서비스: AI 활용 기능(번역·요약·퀴즈·TTS/STT
                등), 문해력·수해력 퀴즈, 키즈 루틴, 키크툰 웹툰 연재, (자녀)
                키즈다 크루 캐릭터 수집, (자녀) 출석 포인트 추가 보너스 및
                회사가 정하는 전용 콘텐츠
              </li>
              <li style={{ fontSize: "small" }}>
                ③ 포인트·쿠폰 등 부가 서비스
              </li>
            </ul>
            <br />
            <p style={{ fontSize: "small" }}>
              2. 회사는 신규 회원에게는 가입 완료 시, 기존 회원에게는 회사가
              정하여 서비스 내 고지하는 바에 따라 1개월 구독 체험권을 제공할 수
              있습니다. 체험권의 제공 여부·범위 및 이용 조건은 서비스 내 고지에
              따르며, 체험 기간이 종료되더라도 회원이 별도로 결제를 신청하지
              않는 한 유료 결제로 자동 전환되지 않습니다. 본 항에 따른 체험권은
              계정당 1회 제공되며, 동일인(휴대폰 본인인증 기준)이 재가입 등으로
              계정을 새로 생성한 경우에는 중복 제공되지 않습니다. 체험권은
              타인에게 양도할 수 없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사는 구독 서비스가 개편되기 전 3개월·6개월·12개월 구독권(이하
              "장기 구독권")을 구매한 회원에게 제2항의 체험권과 별도로 구독
              체험권을 추가 제공할 수 있습니다. 추가 제공되는 체험권의 기간은
              구매한 구독권의 기간에 비례하여 회사가 정하며, 구체적인 산정
              기준·제공 조건 및 이용 방법은 서비스 내 고지에 따릅니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회사는 필요한 경우 서비스 내용을 추가, 변경, 삭제할 수 있으며,
              회원에게 불리한 중대한 변경의 경우 제3조 제3항의 방법으로 사전
              공지합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-9"
            title="제 9 조 (회사의 의무)"
            isOpen={openSections["sec-9"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사는 지속적, 안정적으로 서비스가 제공되도록 최선의 노력을
              다하여야 합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 24시간 365일 서비스 제공을 원칙으로 합니다. 다만
              정기점검, 천재지변, 비상사태 등 부득이한 사유가 발생한 경우
              서비스를 일시 중단할 수 있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-10"
            title="제 10 조 (개인정보의 보호)"
            isOpen={openSections["sec-10"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사는 서비스와 관련하여 수집된 회원의 개인정보를 본인의 사전
              승낙 없이 제3자에게 공개 또는 배포할 수 없습니다. 다만 관련 법령에
              의한 관계기관의 요구가 있을 경우 그러하지 아니합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 개인정보 보호책임자를 비롯한 개인정보에 관한 기타 사항을
              별도로 정한 "개인정보처리방침"에 기재하여 공지합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-11"
            title="제 11 조 (회원의 의무)"
            isOpen={openSections["sec-11"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 계정(ID·비밀번호 및 가입에 사용한 소셜 로그인 계정), 보호자 PIN
              및 연결 코드에 관한 관리책임은 회원에게 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회원은 자신의 계정(소셜 로그인 계정 포함), 자녀 프로필 및 연결
              코드를 제3자에게 양도, 대여할 수 없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회원은 자신의 계정 또는 자녀 프로필이 부정하게 사용된 경우
              반드시 회사에 통보하여야 합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회원은 회원가입 및 자녀 프로필 등록 시 입력항목에 허위, 오기,
              누락이 없도록 하여야 합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. 회원은 자녀의 서비스 이용을 관리·감독할 책임이 있으며, 자녀
              프로필을 통한 이용 행위는 회원의 행위로 봅니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. 회원은 제3자의 권리나 저작권 등을 침해하는 행위를 할 수
              없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              7. 회원은 이 약관 및 관계법령에서 규정한 사항을 준수하여야 하며
              기타 회사의 업무에 방해되는 행위를 하여서는 안됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              8. 회원은 회사의 사전 승낙 없이 서비스를 이용하여 어떠한
              영리행위도 할 수 없습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-12"
            title="제 12 조 (저작권)"
            isOpen={openSections["sec-12"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사의 모든 서비스에 대한 저작권은 회사 및 회사에 콘텐츠를
              제공하는 제공처, 광고주에 있습니다. 이 모든 저작물은 저작권법 및
              관계 법령에 의해 보호받으며 회사, 콘텐츠 제공처, 광고주의 사전
              승낙 없이 복제, 출판, 전송, 배포, 방송 기타 방법에 의하여
              이용하거나 제3자에게 이용하게 할 수 없으며, 저작물에 대한 저작권
              침해는 관계 법령의 적용을 받습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 회원이 서비스 내의 기사의견, 게시판 등에 올린 내용에
              대해 책임이 없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사는 저작권에 관한 기타 사항을 별도로 정한 "저작권정책"에
              기재하여 공지합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-13"
            title="제 13 조 (구독 결제 및 환불)"
            isOpen={openSections["sec-13"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              본 환불 정책은 (주)위고컴퍼니가 운영하는 키즈다 앱 서비스의
              웹사이트(PG 연동 결제)를 통한 유료 구독 결제에 적용됩니다. 인앱
              결제(앱스토어)는 앱스토어의 환불 규정을 따릅니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>구독 상품 및 요금</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              1. 구독 상품 및 요금은 다음과 같습니다 (부가세 포함, 결제 시점
              서비스 내 고지 기준).
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>① 구독 1개월: 4,900원</li>
              <li style={{ fontSize: "small" }}>② 구독 3개월: 14,700원</li>
              <li style={{ fontSize: "small" }}>
                ③ 구독 6개월: 28,900원 (정가 29,400원 대비 약 2% 할인)
              </li>
              <li style={{ fontSize: "small" }}>
                ④ 구독 12개월: 52,900원 (정가 58,800원 대비 약 10% 할인)
              </li>
            </ul>
            <p style={{ fontSize: "small" }}>
              2. 요금이 변경되는 경우 적용일 전에 서비스 내 공지하며, 요금 변경
              이전에 결제된 구독의 이용·환불은 결제 당시의 요금·기준을
              적용합니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>결제 방법</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              1. 이용자는 다음 방법으로 구독 서비스를 결제할 수 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 모바일 앱 내 인앱 결제 (Apple App Store, Google Play Store)
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사 웹사이트를 통한 PG(결제대행) 결제 — 현재 일시 중단. 재개
              시 서비스 내 공지하며, 중단 기간에는 인앱 결제만 제공됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 일시 중단 이전에 PG 결제로 구매한 구독은 이용 기간·환불에
              영향이 없으며, 아래 환불 기준이 계속 적용됩니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>애플 앱스토어 인앱 결제 환불 정책</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              1. 애플 모바일 앱 인앱 결제는 해당 스토어 'Apple App Store'의
              정책에 따라 환불이 진행됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 애플 인앱 결제 환불 요청은 이용자가 직접 앱스토어
              고객지원센터를 통해 신청해야 하며, 회사는 인앱 결제에 대한 환불을
              별도로 처리하지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 스토어 환불 정책에 따라 환불 가능 여부 및 환불 금액이
              결정됩니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>Google Play Store 및 PG 결제 환불 정책</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              Google Play Store 및 회사 웹사이트를 통한 PG 결제 구독에 대해서는
              다음 환불 기준이 적용됩니다.
            </p>
            <br />
            <p style={{ fontSize: "small" }}>
              <strong>① [구독 30일]</strong>
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 &amp; 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 경과 또는 콘텐츠 일부 이용 시: 환불 불가
              </li>
            </ul>
            <br />
            <p style={{ fontSize: "small" }}>
              <strong>② [구독 90일]</strong>
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 &amp; 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 초과 시: 사용 개월 수만큼 정가(월 4,900원) 차감 후 잔여기간
                환불
              </li>
              <li style={{ fontSize: "small" }}>
                예시) 7일 초과 시 당월분(1개월) 서비스 이용, 남은 (2개월)
                잔여기간 환불
              </li>
            </ul>
            <br />
            <p style={{ fontSize: "small" }}>
              <strong>③ [구독 180일]</strong>
            </p>
            <p style={{ fontSize: "small" }}>
              (총 결제 금액: 28,900원 / 약 2% 할인 적용)
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 &amp; 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 초과 시 정가(월 4,900원) 차감 + 할인분(500원) 차감.
              </li>
              <li style={{ fontSize: "small" }}>
                예시) 2개월 사용 시 28,900 − 9,800 − 500 = 18,600원
              </li>
            </ul>
            <br />
            <p style={{ fontSize: "small" }}>
              <strong>④ [구독 365일]</strong>
            </p>
            <p style={{ fontSize: "small" }}>
              (총 결제 금액: 52,900 원 / 약10% 할인 적용)
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 &amp; 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 초과 시: 사용 개월 수만큼 정가(월 4,900원) 차감 +
                할인분(5,860원) 차감 후 잔여금 환불 (환불 시 할인 혜택은 소급
                취소됨)
              </li>
              <li style={{ fontSize: "small" }}>
                예시) 1년 365일권 결제 후 90일 사용 → 차감액 14,700원 + 할인
                취소 5,860원 → 최종 환불액 52,900 − 14,700 − 5,860 = 32,340원
              </li>
            </ul>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>환불 절차 및 유의사항</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              1. 환불은 고객센터 이메일 또는 앱 내 문의 페이지를 통해 신청
              가능합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 환불 요청 시 결제자 정보와 환불 계좌 또는 카드번호가
              필요합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 환불 처리 기간은 영업일 기준 5~7일 이내입니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회사는 환불 요청 시 본인 확인을 위해 본인 인증을 요구할 수
              있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. 결제 대행사(PG사)의 결제 수수료는 회사가 부담하며, 별도
              차감되지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. 콘텐츠 이용 여부 판단은 로그인 기록 및 콘텐츠 열람 이력
              기준으로 합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              7. 프로모션으로 제공된 구독 체험권(제8조 제2항·제3항)은 결제
              이력이 없으므로 환불 대상이 아니며, 체험권 이용 여부는 유료 구독의
              환불 기준(콘텐츠 이용 여부 판단)에 영향을 미치지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              8. 장기 구독권 구매에 따라 추가 제공된 체험권(제8조 제3항)은 해당
              구독권을 중도 해지·환불하는 경우 회수(소멸)될 수 있으며, 세부
              기준은 체험권 제공 시 서비스 내 고지에 따릅니다.
            </p>
            <br />
            <p style={{ fontSize: "small" }}>
              <strong>자동 갱신 안내 및 해지</strong>
            </p>
            <p style={{ fontSize: "small" }}>
              1. 인앱 결제 정기구독은 자동 갱신되며, 갱신일 기준 최소 3일 전
              해지 신청 시 다음 결제는 진행되지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 해지 시점까지 이용한 기간만큼은 정상 청구되며, 잔여기간에 대한
              환불은 위 기준에 따릅니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-14"
            title="제 14 조 (기타)"
            isOpen={openSections["sec-14"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              본 약관은 공정거래위원회 표준 약관에 근거하여 작성되었습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-15"
            title="부칙"
            isOpen={openSections["sec-15"]}
            onToggle={toggleAccordion}
          >
            <p style={{ fontSize: "small" }}>
              <strong>제1조 (시행일)</strong> 이 약관은 2026년 9월 1일부터
              시행합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              <strong>제1조의2</strong> 제13조의 개정 사항(웹사이트 PG 결제 일시
              중단) 및 종전 NIE 캠페인 기부금 조항의 삭제는 2026년 9월 1일부터
              시행합니다 (공고일: 2026년 8월 6일). NIE 캠페인 종료 전에 결제된
              기부금의 환불·처리는 결제 당시의 종전 규정을 적용합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              <strong>제2조 (단계 시행)</strong> 제5조 제2항, 제6조 및 제11조
              제1항 내지 제5항 중 자녀 프로필·기기 연결·보호자 PIN에 관한 사항은
              회원 구조 개편 기능이 적용되는 2026년 10월 중 별도 고지하는 날부터
              시행하며, 회사는 그 적용일을 최소 7일 전 서비스 내 공지사항으로
              고지합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              <strong>제3조 (기존 자녀 계정에 관한 경과조치)</strong> ① 이 약관
              시행 전 만 14세 미만 아동 명의로 가입된 기존 자녀 계정은 제2조의
              기능 적용일부터 보호자 회원의 승인 절차를 거쳐 해당 보호자 계정의
              자녀 프로필로 전환됩니다. ② 전환 시 포인트, 키즈 루틴, 퀴즈
              채점이력, 즐겨찾기 등 이용 정보는 자녀 프로필로 승계됩니다. ③ 기능
              적용일로부터 90일의 유예기간 동안 기존 자녀 계정의 로그인은 임시
              허용되며, 유예기간 경과 후에는 로그인이 제한되고 보호자 계정을 통한
              전환 후 이용할 수 있습니다. ④ 전환이 완료된 기존 자녀 계정의
              아이디·비밀번호는 사용이 중지됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              <strong>제4조 (종전 약관)</strong> 이 약관 시행일 전에 발생한
              사항에 대하여는 종전 약관을 적용합니다.
            </p>
          </AccordionSection>
        </main>

        <aside className="privacy-aside" id="toc">
          <nav className="toc">
            <h4>문서 목차</h4>
            <ul>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-1">제 1 조 - 목적</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-2">제 2 조 - 정의</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-3">제 3 조 - 약관의 효력과 변경</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-4">제 4 조 - 약관 외 준칙</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-5">제 5 조 - 이용계약의 체결</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-6">제 6 조 - 가족 계정 및 자녀 프로필</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-7">제 7 조 - 이용계약의 해지</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-8">제 8 조 - 서비스</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-9">제 9 조 - 회사의 의무</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-10">제 10 조 - 개인정보의 보호</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-11">제 11 조 - 회원의 의무</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-12">제 12 조 - 저작권</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-13">제 13 조 - 구독 결제 및 환불</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-14">제 14 조 - 기타</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-15">부칙</a>
              </li>
            </ul>
          </nav>
        </aside>
      </div>
    </div>
  );
}

export default ServicePage;
